import styled from 'styled-components';

export const HeaderBar = styled.div`
  background: #0a1010;
  border-bottom: 1px solid #1a2424;
  padding: 7px 20px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  z-index: 50;
`;

export const HdrLeft = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const BrandLogo = styled.div`
  width: 365px;
  display: flex;
  align-items: center;
  padding-left: 2px;
  cursor: pointer;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 4px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 9px;
  padding: 4px;
`;

export const Tab = styled.button<{ $active?: boolean }>`
  background: ${({ $active }) => ($active ? '#FF7A10' : 'none')};
  border: none;
  color: ${({ $active }) => ($active ? '#fff' : '#7a9a8a')};
  font-family: var(--body);
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.3px;
  padding: 7px 18px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.18s;
  display: flex;
  align-items: center;
  gap: 7px;
  ${({ $active }) => $active && 'box-shadow: 0 2px 8px rgba(255,122,16,.4);'}

  &:hover:not(:disabled) {
    color: ${({ $active }) => ($active ? '#fff' : '#cfe0d2')};
  }
  &:disabled {
    opacity: 0.32;
    cursor: not-allowed;
  }
`;

export const Pen = styled.span`
  display: inline-block;
  transform: scaleX(-1);
`;
